export { Template as ProductPurchaseSuccessStepTemplate } from './Template';
